import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

var Arrow = function Arrow(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444749",
    strokeWidth: "1.5",
    d: "M16 5l-8 7 8 7"
  })));
};

Arrow.propTypes = {
  className: PropTypes.string
};
var IconArrow = styled(Arrow).withConfig({
  displayName: "icon-arrow__IconArrow",
  componentId: "sc-e7xeme-0"
})(["height:22px;width:22px;vertical-align:middle;transform:", ";transform:", ";transform:", ";"], function (props) {
  return props.direction === 'bottom' ? 'rotate(90deg)' : null;
}, function (props) {
  return props.direction === 'left' ? 'rotate(180deg)' : null;
}, function (props) {
  return props.direction === 'top' ? 'rotate(270deg)' : null;
});
export default IconArrow;